import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {IoWarningOutline} from "react-icons/io5";
import {LiaUserEditSolid} from "react-icons/lia";
import {ImEye} from "react-icons/im";



function SelectVendor() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [title, setTitle] = React.useState(window.localStorage.getItem("vendorTitle"));
    const [theVendor, setTheVendor] = React.useState(window.localStorage.getItem("vendor"));
    const [vendorIndex, setVendorIndex] = React.useState(0);



    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {

                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
                setIsLoaded(true)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });



    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                title
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                         id='active'
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 ">

                        <div className="row main-part mx-2">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted px-0 mx-0">
                             انتخاب مجموعه فعال
                                {isLoaded && user.vendor[vendorIndex]?
                                <img src={isLoaded? user.vendor[vendorIndex]?.cover_photo : ''} alt="Vendor" className='w-100 mt-3 company-cover-photo' /> : '' }
                            </div>
                            {
                                isLoaded && !user.vendor.length &&
                                <div className="alert alert-danger text-center text-small-2">
                                    <div>
                                        <IoWarningOutline className='text-big-5 mb-3' />
                                    </div>
                                    شما مدیر هیچ مجموعه ای نیستید. برای استفاده از امکانات سامانه ابتدا مجموعه خود را ثبت کنید
                                </div>
                            }
                      {/*      <div className="col-12">
                                <div className="alert alert-success text-center text-small-1">
                                    مجموعه ای که می خواهید مدیریت کنید را انتخاب کنید
                                </div>
                            </div>*/}
                            <div className="col-12">
                                <div className='  py-3 text-center btn btn-primary w-100  text-small-1 '
                                     onClick={() => navigate(`/vendor/create`)}
                                     role="button"
                                >
                                    ثبت مجموعه جدید
                                </div>
                            </div>
                            <div className="col-12">
                                {
                                    isLoaded && user?.vendor?.map ((vendor ,index) => {
                                        if(vendor.id === parseInt(theVendor) && index !== vendorIndex) {
                                            setVendorIndex(index);
                                        }
                                        return (
                                            <div className="row vendor-box"
                                            key={vendor.id}
                                                 id={
                                                     vendor.id === parseInt(theVendor) ? 'activeVendor' : 'not-active'
                                                 }
                                                 onClick={ () => {
                                                     setTitle(vendor.title);
                                                     setVendorIndex(index);
                                                     setTheVendor( vendor.id)
                                                     window.localStorage.setItem("vendorTitle", vendor.title);
                                                     window.localStorage.setItem("vendor", vendor.id);
                                                     toast.info( vendor.title + `   به عنوان مجموعه فعال انتخاب شد `)
                                                 } }
                                            >
                                                <div className="col-3">
                                                    <img src={vendor.image} alt={vendor.title} className='w-100 rounded'/>
                                                </div>
                                                <div className="col-9">
                                                   <div className='fw-bold'>
                                                       {vendor.title}
                                                       <span className='tr_code badge badge-pill badge-primary bg-success mx-2 text-small-3 float-start'
                                                       title='تعداد بازدید در اپلیکیشن سوپرمارکت'
                                                       >

                                            {
                                                vendor.hits
                                            }

                                                           &nbsp;
                                                           <ImEye className='text-big-4' />
                                        </span>
                                                   </div>
                                                   <div className='text-small-2 mt-2'>
                                                       {vendor.brief}
                                                   </div>
                                                </div>
                                            </div>
                                        )} )
                                }
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default SelectVendor;